/**
 * Los estados de una orden de venta, y como se muestran.
 *
 * Vive aparte porque lo usan la lista y la ficha. Cuando estaba duplicado,
 * cada pantalla traducia por su cuenta comparando contra el texto que viene
 * de la base — que esta en espanol ("Pendiente", "En proceso"...) — y como
 * las comparaciones eran contra nombres en ingles, ninguna encontraba nada:
 * las dos pantallas mostraban el estado sin color.
 *
 * El codigo numerico es lo estable: es lo que se guarda en pedidos.estado y
 * lo que usan los botones para avanzar la orden.
 */
export const ESTADOS = [
  { codigo: 0, texto: "Pending", clase: "pending", tono: "warn" },
  { codigo: 1, texto: "Processing", clase: "processing", tono: "info" },
  { codigo: 2, texto: "Shipped", clase: "sent", tono: "info" },
  { codigo: 3, texto: "Delivered", clase: "active", tono: "success" },
  { codigo: 4, texto: "Canceled", clase: "inactive", tono: "muted" },
];

const DESCONOCIDO = { codigo: null, clase: "", tono: "muted" };

/**
 * El estado de una orden.
 *
 * Si el codigo no esta en el catalogo se devuelve el texto que haya traido
 * la base, sin color: es preferible mostrar algo raro a mostrar "Pending"
 * cuando no lo es.
 */
export const estadoDe = (pedido) => {
  const encontrado = ESTADOS.find((e) => e.codigo === Number(pedido?.estado));
  if (encontrado) return encontrado;

  return {
    ...DESCONOCIDO,
    texto: pedido?.estado_pedido || pedido?.estado_texto || "Unknown",
  };
};

/**
 * El unico paso que tiene sentido dar ahora mismo.
 *
 * La orden avanza en una sola direccion, asi que solo hay un boton posible.
 * Cancelar no es un paso del flujo y va aparte.
 */
export const siguientePaso = (pedido) => {
  switch (Number(pedido?.estado)) {
    case 0:
      return { codigo: 1, texto: "Process", ayuda: "Change status to Processing" };
    case 1:
      return { codigo: 2, texto: "Send", ayuda: "Change status to Shipped" };
    case 2:
      return { codigo: 3, texto: "Deliver", ayuda: "Change status to Delivered" };
    default:
      // Entregada o cancelada: no hay a donde avanzar.
      return null;
  }
};

export const textoDePago = (pedido) => {
  if (pedido?.pagado === true) return "Paid";
  const v = String(pedido?.estado_pago || "").toUpperCase();
  return v === "PAGADO" || v === "PAID" ? "Paid" : "Not paid";
};

/** Miles con coma: "$5,670.00" se lee de un golpe, "$ 5670.00" hay que contarlo. */
export const formatoUSD = (valor) => {
  const n = Number(valor);
  if (!Number.isFinite(n)) return "—";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  }).format(n);
};
